module.exports = __webpack_public_path__ + "static/media/1POLICY39.7d7650b5.jpg";